// extracted by mini-css-extract-plugin
export var menuIcon = "_s1-0";
export var menuIconInline = "_s1-1";